module.exports = __webpack_public_path__ + "img/modele2_bg_1.a5e360d0.png";